import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Circle = styled.div`
  height: 44px;
  width: 44px;
  background-color: var(--yellow-ochre);
  border-radius: 100%;
  animation: ${bounce} 2s ease-in-out infinite;
`;

const Bar = styled.div`
  margin-top: var(--spacing-0_25);
  width: 40px;
  height: 4px;
  background-color: var(--yellow-ochre);
`;

const Header = styled.h3`
  margin-top: var(--spacing-1);
`;

const BouncingLoadingIcon = ({ message }: { message?: string }) => {
  return (
    <Container>
      <Circle />
      <Bar />
      {message && <Header className="typography-label1">{message}</Header>}
    </Container>
  );
};

export default BouncingLoadingIcon;
